import { DataBean } from "../DataBean";

export class ActiveItemsHistory extends DataBean {



    public async importFixedAssetItemHistory(filename: any, directory: any, dataStore: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importFixedAssetItemHistory_String_String_String_Number", [filename, directory, dataStore, idEmployee]);
    }

}
